import React, { useEffect, useMemo, useState } from "react";
import api from "../../util/panelApi";
import { img, fmt } from "./kit";

/// Acilis (splash) reklamlari. Solda adim adim form, sagda canli telefon onizlemesi.
const DILLER = [
  ["tr", "Türkçe", "🇹🇷"],
  ["ar", "Arapça", "🇸🇦"],
  ["en", "İngilizce", "🇬🇧"],
];
const HEDEFLER = [
  ["", "Hiçbir yere (sadece gösterim)"],
  ["page:store", "Mağaza"],
  ["page:vip", "VIP Kulübü"],
  ["page:recharge", "Coin yükleme"],
  ["page:events", "Etkinlik merkezi"],
  ["page:family", "Aileler"],
  ["room:", "Bir sesli oda (oda no)"],
  ["live:", "Bir yayıncının profili (kullanıcı ID)"],
  ["https://", "Web sayfası (link)"],
];
const ULKELER = [
  ["turkey", "Türkiye"], ["saudi arabia", "Suudi Arabistan"], ["egypt", "Mısır"], ["united arab emirates", "BAE"],
  ["kuwait", "Kuveyt"], ["qatar", "Katar"], ["iraq", "Irak"], ["jordan", "Ürdün"], ["morocco", "Fas"],
  ["algeria", "Cezayir"], ["libya", "Libya"], ["sudan", "Sudan"], ["oman", "Umman"], ["pakistan", "Pakistan"],
];
const BOS = { title: "", seconds: 4, skipAfter: 2, link: "", countries: [], platforms: ["ios", "android"], startsAt: "", endsAt: "", maxPerDay: 3, priority: 0, isActive: true };
const tarihInput = (d) => {
  if (!d) return "";
  const t = new Date(d);
  return new Date(t.getTime() - t.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

const kutu = { background: "#fff", border: "1px solid #E8EAF2", borderRadius: 18, padding: 20, boxShadow: "0 4px 18px rgba(20,20,60,.05)" };
const baslik = (no, t, alt) => (
  <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 14 }}>
    <div style={{ width: 30, height: 30, borderRadius: 10, background: "linear-gradient(135deg,#8E3BFF,#3B6BFF)", color: "#fff", display: "grid", placeItems: "center", fontWeight: 800 }}>{no}</div>
    <div>
      <div style={{ fontWeight: 800, fontSize: 15 }}>{t}</div>
      {alt && <div style={{ fontSize: 12.5, color: "#6B7280" }}>{alt}</div>}
    </div>
  </div>
);
const etiket = { fontSize: 12.5, fontWeight: 700, color: "#374151", marginBottom: 6, display: "block" };
const cip = (on) => ({
  padding: "7px 12px", borderRadius: 99, fontSize: 13, fontWeight: 700, cursor: "pointer", userSelect: "none",
  border: `1px solid ${on ? "#7B5CFF" : "#E5E7EB"}`, background: on ? "#F1ECFF" : "#fff", color: on ? "#5B3FD9" : "#374151",
});

const SplashAds = () => {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);
  const [files, setFiles] = useState({});
  const [onDil, setOnDil] = useState("tr");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const yukle = () => api.splashList().then((r) => r?.status && setRows(r.rows || []));
  useEffect(() => {
    yukle();
  }, []);

  const yeni = () => { setEdit({ ...BOS }); setFiles({}); setMsg(""); setOnDil("tr"); };
  const duzenle = (r) => { setEdit({ ...BOS, ...r }); setFiles({}); setMsg(""); setOnDil("tr"); window.scrollTo(0, 0); };

  const gorselUrl = (lang) => (files[lang] ? URL.createObjectURL(files[lang]) : edit?.images?.[lang] ? img(edit.images[lang]) : "");
  const onizleme = useMemo(() => (edit ? gorselUrl(onDil) || gorselUrl("tr") || gorselUrl("en") || gorselUrl("ar") : ""), [edit, files, onDil]); // eslint-disable-line

  // link: tur + deger
  const linkTur = (() => {
    const l = edit?.link || "";
    if (!l) return "";
    if (l.startsWith("http")) return "https://";
    if (l.startsWith("room:")) return "room:";
    if (l.startsWith("live:")) return "live:";
    return l;
  })();
  const linkDeger = ["room:", "live:"].includes(linkTur) ? (edit?.link || "").slice(5) : linkTur === "https://" ? edit?.link : "";

  const kaydet = async () => {
    setBusy(true);
    const fd = new FormData();
    const g = { ...edit };
    ["_id", "images", "views", "clicks", "skips", "createdAt", "updatedAt"].forEach((k) => delete g[k]);
    Object.entries(g).forEach(([k, v]) => fd.append(k, Array.isArray(v) ? v.join(",") : v ?? ""));
    Object.entries(files).forEach(([lang, f]) => f && fd.append(`image_${lang}`, f));
    const r = edit._id ? await api.splashUpdate(edit._id, fd) : await api.splashCreate(fd);
    setBusy(false);
    setMsg(r?.message || (r?.status ? "Kaydedildi" : "Kaydedilemedi"));
    if (r?.status) { setEdit(null); setFiles({}); yukle(); }
  };
  const sil = async (id) => {
    if (!window.confirm("Bu açılış reklamı silinsin mi?")) return;
    await api.splashDelete(id);
    yukle();
  };
  const ac = async (r) => {
    const fd = new FormData();
    fd.append("isActive", r.isActive ? "false" : "true");
    await api.splashUpdate(r._id, fd);
    yukle();
  };

  const set = (k, v) => setEdit({ ...edit, [k]: v });
  const liste = (k) => (Array.isArray(edit[k]) ? edit[k] : String(edit[k] || "").split(",").filter(Boolean));
  const degistir = (k, v) => {
    const l = liste(k);
    set(k, l.includes(v) ? l.filter((x) => x !== v) : [...l, v]);
  };

  return (
    <div style={{ maxWidth: 1180 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18, gap: 12 }}>
        <div>
          <h4 style={{ margin: 0, fontWeight: 800 }}>Açılış reklamı</h4>
          <div style={{ color: "#6B7280", fontSize: 13.5, marginTop: 4 }}>Uygulama açılırken tam ekran gösterilir. Her dilde ayrı görsel, kullanıcı kendi dilindekini görür.</div>
        </div>
        {!edit && (
          <button className="btn btn-primary" style={{ borderRadius: 12, padding: "10px 18px", fontWeight: 700 }} onClick={yeni}>+ Yeni reklam</button>
        )}
      </div>

      {edit && (
        <div style={{ display: "grid", gridTemplateColumns: "minmax(0,1fr) 300px", gap: 20, alignItems: "start", marginBottom: 26 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={kutu}>
              {baslik(1, "Görseller", "9:16 dikey, önerilen 1080×1920. Boş bıraktığın dilde İngilizce/Türkçe gösterilir.")}
              <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
                {DILLER.map(([lang, ad, bayrak]) => {
                  const u = gorselUrl(lang);
                  return (
                    <label key={lang} onMouseEnter={() => setOnDil(lang)} style={{ cursor: "pointer" }}>
                      <div style={{ width: 118, height: 210, borderRadius: 16, overflow: "hidden", position: "relative", border: `2px ${u ? "solid" : "dashed"} ${onDil === lang ? "#7B5CFF" : "#D6DAE6"}`, background: u ? "#000" : "#F7F8FC" }}>
                        {u ? <img src={u} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : (
                          <div style={{ height: "100%", display: "grid", placeItems: "center", textAlign: "center", color: "#9AA3B5", fontSize: 12.5 }}>
                            <div><div style={{ fontSize: 26 }}>＋</div>Görsel yükle</div>
                          </div>
                        )}
                        <div style={{ position: "absolute", left: 8, bottom: 8, background: "rgba(0,0,0,.6)", color: "#fff", fontSize: 11.5, fontWeight: 700, padding: "3px 8px", borderRadius: 99 }}>{bayrak} {ad}</div>
                      </div>
                      <input type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => { setFiles({ ...files, [lang]: e.target.files[0] }); setOnDil(lang); }} />
                    </label>
                  );
                })}
              </div>
            </div>

            <div style={kutu}>
              {baslik(2, "Süre ve sıklık")}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))", gap: 18 }}>
                <div>
                  <span style={etiket}>Ekranda kalma: <b>{edit.seconds} sn</b></span>
                  <input type="range" min={1} max={10} value={edit.seconds} onChange={(e) => set("seconds", +e.target.value)} style={{ width: "100%" }} />
                </div>
                <div>
                  <span style={etiket}>"Atla" çıksın: <b>{Number(edit.skipAfter) === 0 ? "hemen" : `${edit.skipAfter}. saniyede`}</b></span>
                  <input type="range" min={0} max={edit.seconds} value={Math.min(edit.skipAfter, edit.seconds)} onChange={(e) => set("skipAfter", +e.target.value)} style={{ width: "100%" }} />
                </div>
                <div>
                  <span style={etiket}>Aynı kişiye günde en fazla</span>
                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                    {[1, 2, 3, 5, 0].map((n) => (
                      <span key={n} style={cip(Number(edit.maxPerDay) === n)} onClick={() => set("maxPerDay", n)}>{n === 0 ? "Sınırsız" : `${n} kez`}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div style={kutu}>
              {baslik(3, "Tıklayınca nereye gitsin?")}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <select className="form-control" value={linkTur} onChange={(e) => set("link", ["room:", "live:", "https://"].includes(e.target.value) ? e.target.value : e.target.value)}>
                  {HEDEFLER.map(([v, ad]) => <option key={v} value={v}>{ad}</option>)}
                </select>
                {["room:", "live:", "https://"].includes(linkTur) && (
                  <input
                    className="form-control"
                    placeholder={linkTur === "room:" ? "Oda numarası (örn. 1000)" : linkTur === "live:" ? "Kullanıcı ID" : "https://…"}
                    value={linkDeger}
                    onChange={(e) => set("link", linkTur === "https://" ? e.target.value : linkTur + e.target.value)}
                  />
                )}
              </div>
            </div>

            <div style={kutu}>
              {baslik(4, "Kimler görsün?", "Hiç ülke seçmezsen herkes görür.")}
              <span style={etiket}>Platform</span>
              <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
                {[["ios", " iPhone"], ["android", "🤖 Android"]].map(([p, ad]) => (
                  <span key={p} style={cip(liste("platforms").includes(p))} onClick={() => degistir("platforms", p)}>{ad}</span>
                ))}
              </div>
              <span style={etiket}>Ülkeler</span>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {ULKELER.map(([k, ad]) => <span key={k} style={cip(liste("countries").includes(k))} onClick={() => degistir("countries", k)}>{ad}</span>)}
              </div>
            </div>

            <div style={kutu}>
              {baslik(5, "Yayın zamanı", "Boş bırakırsan hemen başlar, sen kapatana kadar sürer.")}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <div><span style={etiket}>Başlangıç</span><input className="form-control" type="datetime-local" value={tarihInput(edit.startsAt)} onChange={(e) => set("startsAt", e.target.value)} /></div>
                <div><span style={etiket}>Bitiş</span><input className="form-control" type="datetime-local" value={tarihInput(edit.endsAt)} onChange={(e) => set("endsAt", e.target.value)} /></div>
              </div>
              <div style={{ marginTop: 14 }}>
                <span style={etiket}>Ad (sadece sen görürsün)</span>
                <input className="form-control" placeholder="örn. Ramazan kampanyası" value={edit.title} onChange={(e) => set("title", e.target.value)} />
              </div>
            </div>

            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <button className="btn btn-primary" style={{ borderRadius: 12, padding: "11px 26px", fontWeight: 800 }} disabled={busy} onClick={kaydet}>{busy ? "Kaydediliyor…" : edit._id ? "Değişiklikleri kaydet" : "Yayınla"}</button>
              <button className="btn btn-light" style={{ borderRadius: 12, padding: "11px 20px" }} onClick={() => setEdit(null)}>Vazgeç</button>
              <label style={{ display: "flex", gap: 8, alignItems: "center", marginLeft: 8, fontWeight: 700 }}>
                <input type="checkbox" checked={edit.isActive !== false} onChange={(e) => set("isActive", e.target.checked)} /> Yayında
              </label>
              {msg && <span style={{ fontSize: 13, fontWeight: 600 }}>{msg}</span>}
            </div>
          </div>

          {/* canli onizleme */}
          <div style={{ position: "sticky", top: 80 }}>
            <div style={{ display: "flex", gap: 6, justifyContent: "center", marginBottom: 10 }}>
              {DILLER.map(([lang, , bayrak]) => <span key={lang} style={cip(onDil === lang)} onClick={() => setOnDil(lang)}>{bayrak}</span>)}
            </div>
            <div style={{ width: 270, height: 540, margin: "0 auto", borderRadius: 38, padding: 10, background: "#111", boxShadow: "0 20px 50px rgba(20,20,60,.25)" }}>
              <div style={{ width: "100%", height: "100%", borderRadius: 30, overflow: "hidden", position: "relative", background: "linear-gradient(160deg,#2A2380,#0B0820)" }}>
                {onizleme ? <img src={onizleme} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : (
                  <div style={{ height: "100%", display: "grid", placeItems: "center", color: "rgba(255,255,255,.5)", fontSize: 13 }}>Önizleme</div>
                )}
                <div style={{ position: "absolute", top: 14, right: 12, background: "rgba(0,0,0,.55)", color: "#fff", fontSize: 11.5, fontWeight: 700, padding: "5px 11px", borderRadius: 99, border: "1px solid rgba(255,255,255,.25)" }}>
                  {Number(edit.skipAfter) === 0 ? `Atla ${edit.seconds}` : edit.seconds}
                </div>
                {edit.link && (
                  <div style={{ position: "absolute", bottom: 22, left: 0, right: 0, textAlign: "center" }}>
                    <span style={{ background: "linear-gradient(90deg,#8E3BFF,#3B6BFF)", color: "#fff", fontWeight: 800, fontSize: 13, padding: "9px 20px", borderRadius: 99, border: "1px solid #FFC94D" }}>Hemen gör →</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(230px,1fr))", gap: 16 }}>
        {rows.length === 0 && !edit && (
          <div style={{ ...kutu, gridColumn: "1/-1", textAlign: "center", padding: 40, color: "#6B7280" }}>
            Henüz açılış reklamı yok. <b style={{ color: "#5B3FD9", cursor: "pointer" }} onClick={yeni}>İlkini oluştur</b>
          </div>
        )}
        {rows.map((r) => {
          const kapak = r.images?.tr || r.images?.en || r.images?.ar;
          const bitti = r.endsAt && new Date(r.endsAt) < new Date();
          const canli = r.isActive && !bitti;
          return (
            <div key={r._id} style={{ ...kutu, padding: 0, overflow: "hidden" }}>
              <div style={{ height: 320, background: "#0B0820", position: "relative" }}>
                {kapak && <img src={img(kapak)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", opacity: canli ? 1 : 0.35 }} />}
                <span style={{ position: "absolute", top: 10, left: 10, fontSize: 11.5, fontWeight: 800, padding: "4px 10px", borderRadius: 99, background: canli ? "#10B981" : "#6B7280", color: "#fff" }}>
                  {bitti ? "Süresi doldu" : r.isActive ? "● Yayında" : "Kapalı"}
                </span>
                <span style={{ position: "absolute", top: 10, right: 10, fontSize: 13, padding: "3px 8px", borderRadius: 99, background: "rgba(0,0,0,.55)" }}>
                  {DILLER.filter(([l]) => r.images?.[l]).map(([, , b]) => b).join(" ")}
                </span>
              </div>
              <div style={{ padding: 14 }}>
                <div style={{ fontWeight: 800 }}>{r.title || "Adsız reklam"}</div>
                <div style={{ fontSize: 12, color: "#6B7280", marginTop: 2 }}>{r.seconds} sn · {r.countries?.length ? `${r.countries.length} ülke` : "tüm ülkeler"}</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6, marginTop: 10, textAlign: "center" }}>
                  {[["Görülme", r.views], ["Tıklama", r.clicks], ["Tık oranı", r.views ? `%${((r.clicks / r.views) * 100).toFixed(1)}` : "—"]].map(([a, v]) => (
                    <div key={a} style={{ background: "#F7F8FC", borderRadius: 10, padding: "6px 2px" }}>
                      <div style={{ fontWeight: 800, fontSize: 14 }}>{typeof v === "number" ? fmt(v) : v}</div>
                      <div style={{ fontSize: 10.5, color: "#6B7280" }}>{a}</div>
                    </div>
                  ))}
                </div>
                <div style={{ display: "flex", gap: 6, marginTop: 12 }}>
                  <button className="btn btn-light btn-sm" style={{ flex: 1 }} onClick={() => duzenle(r)}>Düzenle</button>
                  <button className="btn btn-light btn-sm" onClick={() => ac(r)}>{r.isActive ? "Durdur" : "Başlat"}</button>
                  <button className="btn btn-light btn-sm" style={{ color: "#DC2626" }} onClick={() => sil(r._id)}>Sil</button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SplashAds;
